/**
 * 路径动画 | 停留动画
 * 2018-12-12
 */

(function (root, factory) {
  if (typeof module === 'object' && typeof module.exports === 'object') {
    // CommonJS
    module.exports = factory(this);
  } else {
    //  全局变量
    factory(root);
  }
})(this, function (root) {
  var methods = {
    ms2fps: function(ms, frameRate) {
      var t = 1000 / frameRate; // 每帧所需时间
      return Math.ceil(ms / t);
    },
    createPathDom: function(id, info, dom, type) {
      var pathStr = 'M';
      var path = info.path;
      if(type === 'Ellipse') {
        // 当类型为椭圆时，path用数组则不好拼接故用字符串
        pathStr = path;
      } else if(type === 'Bessel'){
        var _path = [].concat(path)
        _path.splice(2, 0, "C")
        pathStr += _path.join(' ');
      } else if(type === 'FreePath') {
        pathStr = this.getPathStr(info.points, info.freePathType, info.close)
      } else {
        pathStr += path.join(',');
      }
      // 提供此动画路径dom
      return dom.path(pathStr).attr({
        id: id + '_path_calc'
      })
    },
    getPathStr: function (point, type, close) {
      let path = ''
      if(type === 'line') {
        point.forEach((e, i) => {
          if (i === 0) {
            path = `M ${e[2]} ${e[3]}`
          }else {
            path += ` ${e[2]} ${e[3]}`
          }
        });
        if(close && point.length > 2) {
          path += ` ${point[0][2]} ${point[0][3]} Z`
        }
      }else {
        point.forEach((e, i) => {
          if (i === 0) {
            path = `M ${e[2]} ${e[3]}`
          }else {
            path += ` C ${point[i-1][4]} ${point[i-1][5]} ${e[0]} ${e[1]} ${e[2]} ${e[3]}`
          }
        });
        if(close) {
          path += ` C ${point[point.length-1][4]} ${point[point.length-1][5]} ${point[0][0]} ${point[0][1]} ${point[0][2]} ${point[0][3]} Z`
        }
      }
      return path;
    },
    getPath: function(pathAnim, sprite) {
      // 获取path,概因Line与Ellipse无path
      if(!pathAnim.type || pathAnim.type === 'Path') {
        pathAnim.info = Object.assign({},this.line2path({
          w: sprite.width,
          h: sprite.height,
          x: sprite.positionLeft,
          y: sprite.positionTop
        }, {
          w: pathAnim.target.w,
          h: pathAnim.target.h,
          x: pathAnim.target.x,
          y: pathAnim.target.y
        }));
      }else if(pathAnim.type === 'Ellipse') {
        var cx = rx = pathAnim.info.width / 2,
          cy = ry = pathAnim.info.height / 2;

          pathAnim.info.path = this.ellipse2path(cx, cy, rx, ry, 1);
      }
    },
    getOffset: function(sprite, target, length, type) {
      // 获取动画需要变化之变量
      var data = null;
      if(type === 'Ellipse') {
        data = {
          w: 0,
          h: 0,
          r: 0,
          l: length,
          opacity: 0
        };
      } else {
        data = {
          w: target.w - sprite.width,
          h: target.h - sprite.height,
          r: target.rotate - sprite.rotate,
          l: length,
          opacity: typeof(target.opacity) === 'number' ? target.opacity - sprite.opacity : 0
        };
        if(sprite.type === 'Svg' && sprite.option.fileType === 28 && target.fillColor) {
          var rgb1 = this._hex2rgb(sprite.fill),
              rgb2 = this._hex2rgb(target.fillColor);
          data.rgb = [].concat(rgb1, rgb2);
          data.rgb[6] = rgb2[0] - rgb1[0];
          data.rgb[7] = rgb2[1] - rgb1[1];
          data.rgb[8] = rgb2[2] - rgb1[2];
          data.color = 'fillColor'
        }
        if(sprite.type === 'Text' && target.textColor) {
          var rgb1 = this._hex2rgb(sprite.font.color),
              rgb2 = this._hex2rgb(target.textColor);
          data.rgb = [].concat(rgb1, rgb2);
          data.rgb[6] = rgb2[0] - rgb1[0];
          data.rgb[7] = rgb2[1] - rgb1[1];
          data.rgb[8] = rgb2[2] - rgb1[2];
          data.color = 'textColor'
        }
      }
      return data;
    },
    /*
     * 以下三个函数为速度函数
     * 缓动动画函数接收的4个参数：
     * t: currentIteration 当前的迭代计数（可以视为time或frame）
     * b: startValue 初始值
     * c: changeInValue 变化值（最终值与初始值之差）
     * d: totalIteration 总迭代次数（可视为duration）
     */
    linear: function (t, b, c, d) {
      return c * (t / d) + b;
    },
    easeInOutQuad: function(t, b, c, d) {
      if ((t /= d / 2) < 1) return c / 2 * t * t + b;
      return -c / 2 * ((--t) * (t - 2) - 1) + b;
    },
    easeOutQuint: function (t, b, c, d) {
      return c*((t=t/d-1)*t*t*t*t + 1) + b;
    },
    /**
     * u获取链接两个盒子元素所需路径
     * @param {*} bbox1 需要宽高位置点 (w, h, x, y)
     * @param {*} bbox2
     */
    line2path: function(bbox1, bbox2) {
      var bbox = {};

      bbox1.cx = bbox1.x + bbox1.w / 2;
      bbox1.cy = bbox1.y + bbox1.h / 2;
      bbox2.cx = bbox2.x + bbox2.w / 2;
      bbox2.cy = bbox2.y + bbox2.h / 2;

      bbox.width = Math.abs(bbox1.cx - bbox2.cx);
      bbox.height = Math.abs(bbox1.cy - bbox2.cy);

      // 对应的四个象限和原点
      switch (true) {
        case bbox1.cx < bbox2.cx && bbox1.cy <= bbox2.cy:
          bbox.path = [0, 0, bbox.width, bbox.height];
          bbox.left = bbox1.cx;
          bbox.top = bbox1.cy;
          break;
        case bbox1.cx <= bbox2.cx && bbox1.cy > bbox2.cy:
          bbox.path = [0, bbox.height, bbox.width, 0];
          bbox.left = bbox1.cx;
          bbox.top = bbox2.cy;
          break;
        case bbox1.cx > bbox2.cx && bbox1.cy >= bbox2.cy:
          bbox.path = [bbox.width, bbox.height, 0, 0];
          bbox.left = bbox2.cx;
          bbox.top = bbox2.cy;
          break;
        case bbox1.cx >= bbox2.cx && bbox1.cy < bbox2.cy:
          bbox.path = [bbox.width, 0, 0, bbox.height];
          bbox.left = bbox2.cx;
          bbox.top = bbox1.cy;
          break;
        default:
          bbox.path = [0, 0, 0, 0];
          bbox.left = bbox1.cx;
          bbox.top = bbox1.cy;
          break;
      }

      return bbox;
    },
    /**
     * a 0代表逆时针，1代表顺时针
     */
    ellipse2path: function (cx, cy, rx, ry, a) {
      //非数值单位计算，如当宽度像100%则移除
      // a后面分别意思为x轴半径,y轴半径,椭圆相当于x轴旋转度数，0表明弧线小于180读1大于180度，0表明弧线逆时针旋转1顺时间旋转,终点x,终点y
      if (isNaN(cx - cy + rx - ry)) return;
      var path =
        'M' + (cx-rx) + ' ' + cy +
        'a' + rx + ' ' + ry + ' 0 1 '+ a +' ' + 2*rx + ' 0' +
        'a' + rx + ' ' + ry + ' 0 1 '+ a +' ' + (-2*rx) + ' 0' +
        'z';

      return path;
    },
    /**
     * 方形到路径 (暂时没有用到)
     * @param {*} x 起点x
     * @param {*} y 起点y
     * @param {*} width rect宽
     * @param {*} height rect高
     * @param {*} rx 倒角
     * @param {*} ry
     */
    rect2path: function (x, y, width, height, rx, ry) {
      /* * rx 和 ry 的规则是： * 1. 如果其中一个设置为 0 则圆角不生效 * 2. 如果有一个没有设置则取值为另一个 */
      rx = rx || ry || 0; ry = ry || rx || 0;
      //非数值单位计算，如当宽度像100%则移除
      if (isNaN(x - y + width - height + rx - ry)) return;
      rx = rx > width / 2 ? width / 2 : rx;
      ry = ry > height / 2 ? height / 2 : ry;
      //如果其中一个设置为 0 则圆角不生效
      if(0 == rx || 0 == ry){
        // var path =
        // 'M' + x + ' ' + y +
        // 'H' + (x + width) + 不推荐用绝对路径，相对路径节省代码量
        // 'V' + (y + height) +
        // 'H' + x +
        // 'z';
        var path = 'M' + x + ' ' + y + 'h' + width + 'v' + height + 'h' + -width + 'z';
      }else{
        var path =
          'M' + x + ' ' + (y+ry) +
          'a' + rx + ' ' + ry + ' 0 0 1 ' + rx + ' ' + (-ry) +
          'h' + (width - rx - rx) +
          'a' + rx + ' ' + ry + ' 0 0 1 ' + rx + ' ' + ry +
          'v' + (height - ry -ry) +
          'a' + rx + ' ' + ry + ' 0 0 1 ' + (-rx) + ' ' + ry +
          'h' + (rx + rx -width) +
          'a' + rx + ' ' + ry + ' 0 0 1 ' + (-rx) + ' ' + (-ry) +
          'z';
      }
      return path;
    },
    _rotateWithPoint: function(a, o, deg) {
      //点a围绕o点旋转deg(顺时针)角度后的位置
      var b = {};
      deg = Math.PI/180 * deg;
      b.x = ( a.x - o.x ) * Math.cos(deg) - ( a.y - o.y ) * Math.sin(deg) + o.x;
      b.y = ( a.x - o.x ) * Math.sin(deg) + ( a.y - o.y ) * Math.cos(deg) + o.y;

      return b;
    },
    finallyFrame: function(sprite, info) {
      // 获取元素路径动画结束时的位置信息
      var frameOff = 0,
          ccw = 0,
          exit = 0;

      exit = this.ms2fps(sprite.effect.exitAnim.start, sprite.editor.option.frameRate);

      if(!info.loop) {
        ccw = 0;
        frameOff = info.end - info.start;
      } else {
        frameOff = (exit - info.start) % (info.end - info.start);
        // 圆形不会有顺逆时针之说
        if(info.type !== 'Ellipse') {
          ccw = parseInt((exit - info.start) / (info.end - info.start)) % 2;
        } else{
          ccw = 0;
        }
      }
      return pathOffsetCalc(sprite, info, frameOff, ccw);
    },
    _hex2rgb: function(hex) {
      var arr = [];
      hex = hex.toLowerCase();
      if(hex.length === 4) {
        var shex = '#';
        for(var i=1; i<4; i+=1){
          shex += hex.slice(i,i+1).concat(hex.slice(i,i+1));
        }
        hex = shex;
      }
      for(var i=1; i<7; i+=2) {
        arr.push(parseInt("0x" + hex.slice(i, i+2)));
      }
      return arr
    },
    _rgb2hex: function(arr) {
      return "#" + ((1 << 24) + (arr[0] << 16) + (arr[1] << 8) + arr[2] << 0).toString(16).slice(1);
    },
    getInfoTop: function(sprite, pathAnim) {
      var data = {};

      var currentCenter = {
        x: sprite.positionLeft + sprite.width / 2,
        y: sprite.positionTop + sprite.height / 2
      };

      if(pathAnim.type === 'Ellipse') {
        var calcP = this._rotateLinePoint(currentCenter, pathAnim.info.width/2, pathAnim.info.rotate);
        data.top = calcP.y - pathAnim.info.height / 2;
        data.left = calcP.x;
      }else if(pathAnim.type === 'Bessel'){
        data.top = currentCenter.y - pathAnim.info.path[1];
        data.left = currentCenter.x - pathAnim.info.path[0];
      }else if(pathAnim.type === 'FreePath') {
        data.top = currentCenter.y - pathAnim.info.points[0][3];
        data.left = currentCenter.x - pathAnim.info.points[0][2];
      }

      return data;
    },
    _rotateLinePoint: function(a, len, deg) {
      // 点a是点b由向x轴正方向延伸距离len的点c,然后绕点c旋转deg角度后的，此处求点b
      var b = {};

      deg = -Math.PI/180 * deg || 0;
      b.x = a.x - len * (1 - Math.cos(deg));
      b.y = a.y - len * Math.sin(deg);

      return b;
    },
    WhirlCalc: function(spriteInfo, info, frameOff, frameRate) {
      // 旋转
      var a = {
        x: spriteInfo.x + spriteInfo.w / 2,
        y: spriteInfo.y + spriteInfo.h / 2,
      };
      var o = {
        x: spriteInfo.x + info.position.left * spriteInfo.w,
        y: spriteInfo.y + info.position.top * spriteInfo.h
      };

      o = this._rotateWithPoint(o, a, spriteInfo.rotate)
      // var o = {
      //   x: info.position.left * spriteInfo.tH * 16 / 9,
      //   y:  info.position.top * spriteInfo.tH
      // };
      var rotate = frameOff * info.speed * 360 / frameRate * (info.ccw ? -1 : 1);
      var calcP = this._rotateWithPoint(a, o, rotate)

      return {
        top: calcP.y - spriteInfo.h / 2,
        left: calcP.x - spriteInfo.w / 2,
        rotate: (spriteInfo.rotate + rotate) % 360
      }
    },
    ShakeCalc: function(spriteInfo, info, frameOff, frameRate) {
      // 抖动
      var calcP = {
        x: 0,
        y: 0
      }
      var amp = 0;
      var deg1 = Math.sin(Math.atan2(spriteInfo.h, spriteInfo.w));
          deg2 = Math.sin((spriteInfo.rotate - info.direction) / 180 * Math.PI);
      if(Math.abs(deg1) < Math.abs(deg2)) {
        amp = spriteInfo.h / deg2
      } else {
        amp = spriteInfo.w / Math.cos((spriteInfo.rotate - info.direction) / 180 * Math.PI)
      }
      var off = Math.abs(amp) * info.amplitude * Math.sin(2*Math.PI*frameOff*info.speed / frameRate);
      calcP.x = off * Math.cos(info.direction / 180 * Math.PI)
      calcP.y = off * Math.sin(info.direction / 180 * Math.PI)
      return {
        top: spriteInfo.y + calcP.y,
        left: spriteInfo.x + calcP.x,
        rotate: spriteInfo.rotate
      }
    }
  }

  function initPathData (sprite) {
    // 为路径动画的初始化需要的信息
    if(!sprite.effect.pathAnim.end) return;
    var pathAnim = sprite.effect.pathAnim,
        frameRate = sprite.editor.option.frameRate || 60,
        data = {
          start: methods.ms2fps(pathAnim.start, frameRate),
          end: methods.ms2fps(pathAnim.end === pathAnim.start ? pathAnim.end + 500 : pathAnim.end, frameRate),
          loop: pathAnim.loop,
          type: pathAnim.type || 'Path'
        };
      // 重新绘制路径元素(i其实info.path没有变化的话可以不用重新生成)
      pathAnim.pathDom && pathAnim.pathDom.remove();
      methods.getPath(pathAnim, sprite);
      pathAnim.pathDom = methods.createPathDom(sprite.id, pathAnim.info, sprite.editor.svgForPath, pathAnim.type);
      data.length = pathAnim.pathDom.length();

      if(pathAnim.info.top) {
        data.top = pathAnim.info.top;
        data.left = pathAnim.info.left;
      } else {
        data = Object.assign(data, methods.getInfoTop(sprite, pathAnim));
      }
      // 此处target为路径动画最后应该停留的位置和大小
      data.target = methods.finallyFrame(sprite, data);

    return data;
  }

  function initStayData (sprite) {
    if(sprite.effect.stayAnim.type === 'None') return;

    var animFrame = sprite.effect.animFrame,
        frameRate = sprite.editor.option.frameRate || 60,
        bbox = {
          w: sprite.width,
          h: sprite.height,
          x: sprite.positionLeft,
          y: sprite.positionTop,
          rotate: sprite.rotate,
          tH: sprite.editor.clientHeight
        },
        frameOff = animFrame.exit.start - animFrame.entrance.end;

    return stayOffsetCalc(bbox, sprite.effect.stayAnim, frameOff, frameRate)
  }

  /**
   * 为动画最为重要的函数，计算元素在对应帧应该在的位置和大小
   * @param {*} sprite 本元素
   * @param {*} info 初始化的data对象
   * @param {*} frameOff 帧
   * @param {*} ccw 是否为逆时针
   */
  function pathOffsetCalc(sprite, info, frameOff, ccw) {
    var pathAnim = sprite.effect.pathAnim,
        frameRate = sprite.editor.option.frameRate || 60,
        totalTime = pathAnim.end - pathAnim.start < 500 ? 500 : pathAnim.end - pathAnim.start,
        total = totalTime / 1000 * frameRate,
        distance = methods.getOffset(sprite, pathAnim.target, info.length, pathAnim.type),
        data = {},
        position;

    if(!pathAnim.easing) pathAnim.easing = 'easeInOutQuad';

    if (!ccw) {
      position = pathAnim.pathDom.pointAt(methods[pathAnim.easing](frameOff, 0, distance.l, total));
      data.opacity = methods[pathAnim.easing](frameOff, sprite.opacity, distance.opacity, total);
      if(distance.rgb) {
        var arr = [];
        arr[0] = methods[pathAnim.easing](frameOff, distance.rgb[0], distance.rgb[6], total);
        arr[1] = methods[pathAnim.easing](frameOff, distance.rgb[1], distance.rgb[7], total);
        arr[2] = methods[pathAnim.easing](frameOff, distance.rgb[2], distance.rgb[8], total);
        data[distance.color] = methods._rgb2hex(arr);
      }
      data.width = methods[pathAnim.easing](frameOff, sprite.width, distance.w, total);
      data.height = methods[pathAnim.easing](frameOff, sprite.height, distance.h, total);
      data.rotate = methods[pathAnim.easing](frameOff, sprite.rotate, distance.r, total);
    }else {
      position = pathAnim.pathDom.pointAt(methods[pathAnim.easing](frameOff, distance.l, -distance.l, total));
      data.opacity = methods[pathAnim.easing](frameOff, sprite.opacity + distance.opacity, -distance.opacity, total);
      if(distance.rgb) {
        var arr = [];
        arr[0] = methods[pathAnim.easing](frameOff, distance.rgb[3], -distance.rgb[6], total);
        arr[1] = methods[pathAnim.easing](frameOff, distance.rgb[4], -distance.rgb[7], total);
        arr[2] = methods[pathAnim.easing](frameOff, distance.rgb[5], -distance.rgb[8], total);
        data[distance.color] = methods._rgb2hex(arr);
      }
      data.width = methods[pathAnim.easing](frameOff, pathAnim.target.w, -distance.w, total);
      data.height = methods[pathAnim.easing](frameOff, pathAnim.target.h, -distance.h, total);
      data.rotate = methods[pathAnim.easing](frameOff, pathAnim.target.rotate, -distance.r, total);
    }
    // 只有ellipse会有路径旋转的问题。
    if(pathAnim.type === 'Ellipse') {
      position = methods._rotateWithPoint(position, {x: pathAnim.info.width / 2, y: pathAnim.info.height /2 }, pathAnim.info.rotate);
    }

    // data.opacity = methods.linear(frameOff, sprite.opacity, distance.opacity, total);
    data.left = position.x + info.left - data.width / 2;
    data.top = position.y + info.top - data.height / 2;

    return data;
  }

  function changeSvgFillColor(dom, hex) {

    var svg = dom.querySelector('svg');
    var nodeList = [].slice.call(svg.querySelectorAll('*'), 1);
    var urlFillRE = /url\(.*#.*\)/;
    nodeList.forEach((el) => {
      var $el = $(el);
      var attrFill = $el.css('fill');
      var isUrlFill
      if (urlFillRE.test(attrFill)) {
            var isUrlFill = true;
        }
      if (
        attrFill && attrFill !== 'none' && attrFill !== 'transparent' &&
        el.tagName != 'defs' && el.tagName != 'style'
        && !isUrlFill
      ) {
        el.setAttribute('fill', hex || attrFill);
        $el.css('fill', hex || attrFill);
        $el.css('stop-color', hex || attrFill);
      }
    })
  }

  function stayOffsetCalc(spriteInfo, info, frameOff, frameRate) {
    if(!methods[info.type + 'Calc']) return;
    return methods[info.type + 'Calc'](spriteInfo, info, frameOff, frameRate)
  }

  if (root.AnimEditor) {
    // 挂载到SceneEffects
    root.AnimEditor.pathOffsetCalc = pathOffsetCalc;
    root.AnimEditor.stayOffsetCalc = stayOffsetCalc;
    root.AnimEditor.initPathData = initPathData;
    root.AnimEditor.initStayData = initStayData;
    root.AnimEditor.changeSvgFillColor = changeSvgFillColor;
    return;
  }

  return function (AnimEditor) {
    // 挂载到SceneEffects
    AnimEditor.pathOffsetCalc = pathOffsetCalc;
    AnimEditor.stayOffsetCalc = stayOffsetCalc;
    AnimEditor.initPathData = initPathData;
    AnimEditor.initStayData = initStayData;
    AnimEditor.changeSvgFillColor = changeSvgFillColor;
  }
});



//////////////////
// WEBPACK FOOTER
// ./static/animengine/js/path-effects/calcOffset.js
// module id = MSEh
// module chunks = 16